import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#2C5E43', // Elegant Deep Sage Green
      light: '#4E8064',
      dark: '#1B3B2B',
      contrastText: '#FCFBF9',
    },
    secondary: {
      main: '#B08968', // Luxury Warm Muted Gold
      light: '#D3B598',
      dark: '#7F5E39',
      contrastText: '#FCFBF9',
    },
    background: {
      default: '#FCFBF9', // Calming Alabaster Off-white
      paper: '#FFFFFF',
    },
    text: {
      primary: '#1E2421', // Dark charcoal green
      secondary: '#5A6E63', // Muted sage slate
    },
  },
  typography: {
    fontFamily: [
      'Outfit',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
    ].join(','),
    h1: {
      fontFamily: "'Playfair Display', serif",
      fontWeight: 600,
    },
    h2: {
      fontFamily: "'Playfair Display', serif",
      fontWeight: 600,
    },
    h3: {
      fontFamily: "'Playfair Display', serif",
      fontWeight: 600,
    },
    h4: {
      fontFamily: "'Playfair Display', serif",
      fontWeight: 600,
    },
    h5: {
      fontFamily: "'Playfair Display', serif",
      fontWeight: 500,
    },
    h6: {
      fontFamily: "'Playfair Display', serif",
      fontWeight: 500,
    },
    subtitle1: {
      fontFamily: 'Outfit',
      fontWeight: 400,
    },
    subtitle2: {
      fontFamily: 'Outfit',
      fontWeight: 500,
    },
    body1: {
      fontFamily: 'Outfit',
      lineHeight: 1.7,
    },
    body2: {
      fontFamily: 'Outfit',
      lineHeight: 1.6,
    },
    button: {
      fontFamily: 'Outfit',
      textTransform: 'none',
      fontWeight: 500,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '30px', // Premium rounded capsule style
          padding: '10px 28px',
          fontSize: '0.95rem',
          transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
          boxShadow: 'none',
          '&:hover': {
            boxShadow: '0 4px 14px rgba(44, 94, 67, 0.2)',
            transform: 'translateY(-1px)',
          },
        },
        containedPrimary: {
          background: 'linear-gradient(135deg, #2C5E43 0%, #3B6B50 100%)',
          '&:hover': {
            background: 'linear-gradient(135deg, #1B3B2B 0%, #2C5E43 100%)',
            boxShadow: '0 6px 20px rgba(44, 94, 67, 0.3)',
          },
        },
        containedSecondary: {
          background: 'linear-gradient(135deg, #B08968 0%, #C5A880 100%)',
          '&:hover': {
            background: 'linear-gradient(135deg, #7F5E39 0%, #B08968 100%)',
            boxShadow: '0 6px 20px rgba(176, 137, 104, 0.3)',
          },
        },
        outlinedPrimary: {
          borderColor: '#2C5E43',
          borderWidth: '1.5px',
          color: '#2C5E43',
          '&:hover': {
            borderWidth: '1.5px',
            background: 'rgba(44, 94, 67, 0.04)',
          },
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
        },
      },
    },
  },
});

export default theme;
